export interface BOMItem {
  materialId: string;
  description: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  totalPrice: number;
}

export interface BOMSnapshot {
  items: BOMItem[];
  totalPrice: number;
  totalWeight: number;
  totalLoadCapacity: number;
}

export interface QuotationConfiguration {
  model: string;
  height: number;
  width: number;
  depth: number;
  shelfCount: number;
  sectionCount: number;
  sides: string;
  frameState: string;
}

export interface Quotation {
  id: string;
  created_at: string;
  status: string;
  company: string;
  contact_name: string;
  email: string;
  phone: string | null;
  address: string | null;
  postal_code: string;
  city: string;
  country: string;
  shipping_method: string;
  notes: string | null;
  configuration: QuotationConfiguration | null;
  bom_snapshot: BOMSnapshot | null;
  reseller_id: string | null;
  user_id: string | null;
  reseller_name?: string;
  user_email?: string;
}

export const STATUS_COLORS: Record<string, string> = {
  pending: 'bg-amber-100 text-amber-700',
  processed: 'bg-green-100 text-green-700',
  declined: 'bg-red-100 text-red-700',
};

export const STATUS_OPTIONS = ['pending', 'processed', 'declined'];

export function formatQuotationDate(iso: string) {
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso));
}
